import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=ca333628&"
import script from "./PurchaseList.vue?vue&type=script&lang=js&"
export * from "./PurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=ca333628&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports